var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVg = function SvgIconVg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.969 12H12v-.031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.262V0h-.002C5.371.002 0 5.374 0 12.001h6.26V8.475l3.526 3.526h2.182l.032-.032V9.787L8.474 6.262z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M6.07 1.564A12.06 12.06 0 0 0 1.564 6.07v5.929h3.13V4.695H12v-3.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m17.218 12-3.243 3.243a3.65 3.65 0 0 0 6.487 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 10.524 7.736 6.261H6.261L12 12.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M13.565 6.261v5.74c0 2.795 3.653 3.651 3.653 3.651S20.87 14.796 20.87 12V6.261z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M18 8.87h-1.565v4.174H18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M17.217 9.652a.783.783 0 1 0 0-1.566.783.783 0 0 0 0 1.566"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.653 7.305h-1.044v1.043h1.044zM15.652 9.652h-1.044v1.043h1.044zM15.652 12h-1.044v1.044h1.044zM19.826 7.305h-1.044V8.35h1.044zM19.826 9.652h-1.044v1.043h1.044zM19.826 12h-1.044v1.044h1.044z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconVg;